<!--
 * @Author: 张韶杰
 * @Date: 2024-10-31 18:05:04
 * @LastEditors: 汪永康 wangyongkang@yxj.org.cn
 * @LastEditTime: 2026-07-26 12:53:54
 * @FilePath: \ysz_web_international_h5\src\components\commonTop.vue
 * @Description: 
 * 
-->
<template>
    <div
        class="common_top"
        :class="{ scrolled: isScrolled, 'with-search': showSearch }"
    >
        <div class="common_top_main">
            <!-- <van-icon name="list-switch" color="#858585" size="30" @click="isMenuShow = !isMenuShow" /> -->
            <div class="switch_btn" @click="isMenuShow = !isMenuShow"></div>
            <div class="logo" @click="toHome"></div>
            <!-- <van-icon @click="showSearch" name="search" color="#858585" size="30" /> -->
        </div>
        <div class="search_box" v-if="showSearch">
            <input v-model="keywords" type="text" placeholder="Search" autocomplete="off" />
            <div class="search_btn" @click="toSearch"></div>
        </div>
        <van-popup v-model="isMenuShow" position="left" :overlay-style="{ background: 'rgba(0, 0, 0, 0.5)' }"
            class="menu_popup">
            <div class="menu_list">
                <div class="menu_item" :class="{ 'active': $route.path === '/' }" @click="toHome">Home</div>

                <div class="menu_item menu_item_toggle" :class="{
                    'expanded': !isInnovationCollapse,
                    'active': isInnovationActive
                }" @click="isInnovationCollapse = !isInnovationCollapse">
                    <span>Inovation Therapy</span>
                    <i class="menu_arrow"></i>
                </div>
                <div class="menu_sub_list" v-if="!isInnovationCollapse">
                    <div class="menu_sub_item"
                        :class="{ 'active': $route.path === '/innovation_tracker' || $route.path === '/innovation_tracker_deep_analysis' }"
                        @click="toPath('/innovation_tracker')">Innovation Tracker</div>
                    <div class="menu_sub_item" :class="{ 'active': $route.path === '/innovation_tracker_latest_news' }"
                        @click="toPath('/innovation_tracker_latest_news')">Latest News</div>
                    <div class="menu_sub_item"
                        :class="{ 'active': $route.path === '/innovation_tracker_frontier_research' }"
                        @click="toPath('/innovation_tracker_frontier_research')">Frontier Research</div>
                </div>

                <div class="menu_item" :class="{ 'active': $route.path.indexOf('/doctors') === 0 }" @click="toDoctors">
                    Doctors</div>
                <div class="menu_item" :class="{ 'active': $route.path.indexOf('/conferences') === 0 }"
                    @click="toPath('/conferences')">Conferences</div>
                <div class="menu_item" :class="{ 'active': $route.path === '/webinar' }" @click="toPath('/webinar')">
                    Webinar</div>
                <div class="menu_item" :class="{ 'active': $route.path.indexOf('/about') === 0 }" @click="toAbout">About
                </div>
                <template v-if="isLogin">
                    <div class="menu_item" :class="{ 'active': $route.path === '/account' }" @click="toAccount">My
                        account information</div>
                    <div class="menu_item" :class="{ 'active': $route.path === '/collection' }" @click="toCollection">My
                        collection</div>
                    <div class="menu_item" @click="handelLoginOut">Log out</div>
                </template>
                <template v-else>
                    <div class="menu_item"
                        :class="{ 'active': $route.path === '/login_register' && String($route.query.type) === '2' }"
                        @click="handelGotoLogin(2)">Register</div>
                    <div class="menu_item"
                        :class="{ 'active': $route.path === '/login_register' && String($route.query.type) === '1' }"
                        @click="handelGotoLogin(1)">Log in</div>
                </template>
            </div>
        </van-popup>
    </div>
</template>
<script>
import { Popup, Icon, Toast } from 'vant';
import { Collapse, CollapseItem } from 'vant';
import { mapGetters, mapActions } from "vuex";
export default {
    name: 'CommonTop',
    components: {
        [Popup.name]: Popup,
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem,
        [Icon.name]: Icon
    },
    props: {
        showSearch: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        ...mapGetters({
            isLogin: 'isLogin',
            userInfo: 'userInfo',
            // activeNavName: 'activeNavName'
        }),
        isInnovationActive () {
            const path = this.$route.path
            return path.indexOf('/innovation_tracker') === 0
        }
    },
    data () {
        return {
            keywords: '',
            activeNames: [],
            isMenuShow: false,
            // isSearchBarShow: false,
            isInnovationCollapse: false,
            isScrolled: false,
        }
    },
    created () {
        this.updateScrollState();
        window.addEventListener('scroll', this.updateScrollState, { passive: true });
    },
    beforeDestroy () {
        window.removeEventListener('scroll', this.updateScrollState);
    },
    watch: {
        keywords: {
            handler (val) {
                this.$emit('handleKeyword', val)
            },
            immediate: true
        },
        '$route' () {
            this.$nextTick(() => {
                this.updateScrollState();
            });
        },
    },
    methods: {
        ...mapActions({
            setIsLogin: "setIsLogin",
            Logout: 'Logout',
            // setAcchorName: 'setAcchorName'
        }),
        updateScrollState () {
            this.isScrolled = (window.pageYOffset || document.documentElement.scrollTop || 0) > 0;
        },
        // showSearch() {
        //     this.isSearchBarShow = true
        //     this.$nextTick(() => {
        //         this.$refs.autofocusInput.focus()
        //     })
        // },
        toSearch () {
            if (!this.keywords) {
                Toast('Please input the search content')
                return
            }
            if (this.$route.path === '/search') {
                this.$emit('handleSearch')
            } else {
                // sessionStorage.removeItem('searchTime')
                this.$router.push({
                    path: '/search',
                    query: {
                        keyword: this.keywords
                    }
                })
            }

            this.isSearchBarShow = false
            this.isMenuShow = false
        },
        handelGotoLogin (val) {
            this.$router.push({
                path: '/login_register',
                query: {
                    type: val
                }
            })
            this.isMenuShow = false
        },
        toHome () {
            this.$router.push({
                path: '/',
            })
            this.isMenuShow = false
        },
        toAbout () {
            this.$router.push({
                path: '/about',
            })
            this.isMenuShow = false
        },
        toAccount () {
            this.$router.push({
                path: '/account',
            })
            this.isMenuShow = false
        },
        toCollection () {
            this.$router.push({
                path: '/collection',
            })
            this.isMenuShow = false
        },
        toArticles (contentType) {
            this.$router.push({
                path: '/articles',
                query: {
                    contentType
                }
            })
            this.isMenuShow = false
        },
        toDoctors () {
            this.$router.push({
                path: '/doctors',
            })
            this.isMenuShow = false
        },
        toPath (path) {
            this.$router.push({ path })
            this.isMenuShow = false
        },
        //退出登录
        handelLoginOut () {
            this.setIsLogin(false)
            this.Logout()
            this.isMenuShow = false
        },
    }
}
</script>
<style lang="scss" scoped>
.common_top {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 100;
    box-sizing: border-box;
    // 有搜索栏：内容区 100 + padding-bottom 12 = 112（border-box 下 padding 计入 height）
    height: 44px;
    padding-bottom: 0;
    background-color: #fff;
    transition: background-color 0.3s ease;

    &.with-search {
        height: 112px;
        padding-bottom: 12px;
    }

    &.scrolled {
        background-color: #000;
    }

    .common_top_main {
        padding: 0 16px;
        height: 44px;
        // padding: 0 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-color: #000;

        .switch_btn {
            width: 18px;
            height: 18px;
            background-image: url(../assets/images/switch_btn.png);
            background-size: 100% 100%;
            background-repeat: no-repeat;
            background-position: center;
        }

        .logo {
            width: 41px;
            height: 20px;
            background-image: url(../assets/images/logo.png);
            background-size: 100% 100%;
        }
    }

    .search_box {
        margin-top: 12px;
        margin-left: 50%;
        transform: translateX(-50%);
        width: 343px;
        height: 38px;
        background-image: url(../assets/images/main_search_img.png);
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;

        input {
            font-family: Manrope;
            line-height: 0;
            flex: 1;
            outline: none;
            border: none;
            margin-left: 8px;
            margin-right: 10px;
        }

        .search_btn {
            width: 50px;
            height: 38px;
        }
    }

    .menu_list {
        box-sizing: border-box;
        width: 283px;
        height: 100%;
        padding: 16px 0;
        background: #FFFFFF;
        overflow-y: auto;

        .menu_item {
            box-sizing: border-box;
            width: 251px;
            height: 50px;
            margin: 0 16px;
            padding: 0;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-family: "Times New Roman", Times, serif;
            font-size: 18px;
            font-weight: 700;
            line-height: 18px;
            text-transform: uppercase;
            color: #333333;

            &.active {
                color: #C9151E;
            }

            &.menu_item_toggle {
                .menu_arrow {
                    display: block;
                    flex-shrink: 0;
                    width: 10px;
                    height: 6px;
                    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='3.335 5.334 9.33 5.331'%3E%3Cpath d='M8,6.94234359L11.5288281,10.4711719L11.5298681,10.4701319Q11.623383,10.5636473,11.7455664,10.6142569Q11.8677497,10.6648669,12,10.6648669Q12.0654831,10.6648664,12.1297092,10.6520915Q12.1939335,10.6393156,12.2544327,10.6142564Q12.3149319,10.5891967,12.36938,10.5528159Q12.4238281,10.5164351,12.4701319,10.4701314Q12.5164356,10.4238272,12.5528164,10.36938Q12.5891972,10.3149319,12.6142559,10.2544332Q12.6393156,10.1939344,12.652091,10.1297092Q12.6648674,10.0654836,12.6648674,10Q12.6648674,9.8677492,12.6142569,9.7455659Q12.5636463,9.6233826,12.4701319,9.5298676L12.4711714,9.5288281L8.4711719,5.52882826Q8.4247651,5.48242193,8.3701968,5.4459607Q8.315629,5.40949947,8.2549958,5.38438451Q8.1943631,5.35926962,8.1299953,5.34646612Q8.0656281,5.33366263,8,5.33366263Q7.934371,5.33366263,7.8700037,5.34646612Q7.8056359,5.35926962,7.7450032,5.38438457Q7.6843705,5.40949953,7.6298025,5.4459607Q7.5752344,5.48242193,7.5288281,5.52882826L3.52882826,9.5288281L3.5298681,9.5298679Q3.43635297,9.623383,3.38574296,9.7455664Q3.33513296,9.8677497,3.33513296,10Q3.33513296,10.0654836,3.3479082,10.1297088Q3.36068344,10.1939344,3.38574296,10.2544332Q3.41080248,10.3149319,3.44718325,10.36938Q3.48356402,10.4238272,3.52986801,10.4701314Q3.57617199,10.5164351,3.63061967,10.5528159Q3.68506736,10.5891967,3.7455664,10.6142564Q3.80606544,10.6393156,3.87029088,10.6520915Q3.93451631,10.6648664,4,10.6648669Q4.13225023,10.6648664,4.25443351,10.6142569Q4.37661684,10.5636468,4.4701319,10.4701319L4.47117174,10.4711719L8,6.94234359Z' fill='%23A1A1A1'/%3E%3C/svg%3E");
                    background-size: 100% 100%;
                    background-repeat: no-repeat;
                    transition: transform 0.2s ease;
                    transform: rotate(180deg);
                }

                &.expanded .menu_arrow {
                    transform: rotate(0deg);
                }
            }
        }

        .menu_sub_list {
            width: 251px;
            margin: 0 16px;
            background: #F8F8F8;
            margin-bottom: 8px;
        }

        .menu_sub_item {
            box-sizing: border-box;
            position: relative;
            height: 44px;
            padding: 0 0 0 27px;
            display: flex;
            align-items: center;
            font-family: Manrope, sans-serif;
            font-size: 14px;
            font-weight: 400;
            line-height: 14px;
            text-transform: uppercase;
            color: #666666;

            &::before {
                content: '';
                position: absolute;
                left: 15px;
                top: 50%;
                width: 4px;
                height: 4px;
                margin-top: -2px;
                border-radius: 50%;
                background: #C9151E;
            }

            &.active {
                color: #C9151E;
            }
        }
    }
}
</style>

<style lang="scss">
.menu_popup.van-popup {
    width: 283px;
    height: 100%;
    background: #FFFFFF;
}
</style>